<template>
<div class="edit-area">
  <div class="container-base fullscreen"
    v-show="!previewDialogVisible">
    <h1>
      <router-link :to="{name: 'formatDetail', params: {formatId: formatId}}">{{ currentFormat.title }}</router-link>
    </h1>
    <div class="overflow-scroll-x step"
      ref="step">
      <ol>
        <li v-for="(item, index) in currentFormat.cards"
          :ref="'steps'"
          :key="item.id"
          :index="index"
          :class="{current:(item.id == currentCardId),
                     over:(index < currentCardIndex)}"
          v-ripple>
          <a href="#"
             @click="goCardTo(item.id);$event.preventDefault()">
            {{ item.title }}
          </a>
        </li>
      </ol>
    </div>
    <v-touch v-bind:enabled="{swipe:true, press:false, pan:false, tap:false, rotate:false, pinch:false}"
      v-on:swipeleft="swipeNextCard"
      v-on:swiperight="swipePrevCard"
      v-bind:swipe-options="{direction:'horizontal'}">
      <div class="cards"
        v-show="currentCardId">
        <component v-bind:is="basicInfo"
          ref="editBasic"
          :basic-data="basicData"
          :requiredBasicFields="requiredBasicFields"
          :current-card-id="currentCardId"></component>

        <component v-bind:is="currentFormat.components.edit"
          ref="editFormat"
          :basic-data="basicData"
          :format-id="formatId"
          :preview-format="$refs.previewFormat"
          :example-sentences="exampleSentences"
          :current-card-id="currentCardId"></component>

        <div class="card-pager-nav">
          <div class="pager">
            <el-button v-ripple
              @click="goNextCard"
              :disabled="!isNextCardAvailable"
              style="background-color:#E95B10;border-color:#E95B10;"
              type="primary">
              次へ <i class="el-icon-d-arrow-right"></i>
            </el-button>

            <el-button v-ripple
              icon="el-icon-d-arrow-left"
              @click="goPrevCard"
              :type="isNextCardAvailable ? 'text': 'primary'"
              style="color:#E95B10;background-color:#FFF;border-color:#FFF;"
              :disabled="!isPrevCardAvailable">
              前へ
            </el-button>
          </div>
        </div>

        <div class="text-right">
          <div class="save-time-message"
            v-show="saveNotifyMessage"
            v-if="$yagi.profile.autoSaveEnabled">
            <span>最終保存：</span> <span v-html="saveNotifyMessage"></span>
          </div>
          <div v-else>
            <el-button @click="$eventHub.$emit('open-account-dialog')"
              type="text">ブラウザに自動保存: オフ</el-button>
          </div>
        </div>

        <div class="card-preview-button">
          <el-button v-ripple
            v-if="!$firebase.isAuthenticated"
            plain
            @click="showTempdata"
            type="success"
            style="background-color:#e3165c;border-color:#e3165c;color:#FFF"
            id="preview-button-format-edit"><i class="el-icon-upload"></i> 自動バックアップ</el-button>
          <el-button v-ripple
            v-if="false"
            plain
            @click="loadTempdata"
            type="success"
            style="background-color:#03160c;border-color:#03160c;color:#FFF"
            id="preview-button-format-edit"><i class="el-icon-upload"></i> 一時保存データから復旧</el-button><br><br>
          <el-button v-ripple
            plain
            @click="showPreview"
            type="success"
            style="background-color:#0F9934;border-color:#0F9934;color:#FFFFFF"
            id="preview-button-format-edit"><i class="el-icon-view"></i> プレビュー</el-button>
        </div>
      </div>
    </v-touch>
  </div>

  <div class="preview-dialog"
    :style="previewDialogStyleObject"
    ref="previewDialog">
    <div class="preview-action">
      <div class="container-base">
        <ul>
          <li id="close-preview-button-above">
            <el-button class="button-block"
              @click="closePreview"
              type="success"
              id="buckt-to-edit-button-format-edit"
              v-ripple><i class="el-icon-d-arrow-left"></i> 入力画面に戻る</el-button>
          </li>
        </ul>
      </div>
    </div>
    <div class="blog-widghet">
      <div class="blog-widghet-inner success">
        <ul class="blog-widghet-list">
          <li>
            <a class="blog-entry-link">
              <div class="left"></div>
              <div class="right">
                <div class="title">【注意！】印刷・ダウンロード前に、レイアウト崩れがないかご確認ください。</div>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="preview-tabs">
      <div class="edit-form-item">
        <h3>フォント選択 </h3>
        <div class="item-body">
          <el-select v-model="formatData.selFont"
          @change="selectFont"
          :style="formatData.selFontStyle"
            placeholder="選択してください">
            <el-option v-for="item in fontOptions"
              :key="item.value"
              :label="item.label"
              :style="item.value"
              :value="item.value"></el-option>
          </el-select>
          <br>
          <span style="font-size: 90%;color:red;">※試用期間につき2023年1月31日までは無料で利用できます。</span>
          <el-button id="send-adtop-pdf" type="success" 
          v-if="false"
        style="background-color:#0F9934;border-color:#0F9934;"
          @click="closeMedleyDialog();">購入する</el-button>
        </div>
      </div>
      <input id="user-viewer-tab"
             type="radio"
             name="preview-tab-active"
             v-model="previewTabActive"
             value="previewFormat">
      <label class="tab-item"
             for="user-viewer-tab">プレビュー</label>

      <input id="example-viewer-tab"
             type="radio"
             name="preview-tab-active"
             v-model="previewTabActive"
             value="sampleFormat">
      <label class="tab-item"
             for="example-viewer-tab">記入例</label>

      <div id="preview-viewer"
        v-show="previewTabActive == 'previewFormat'"
        class="preview-viewer tab-content"
        :style="previewViewerCss"
        ref="previewViewer">
        <component v-bind:is="currentFormat.components.preview"
          ref="previewFormat"
          :id-prefix="''"
          :format-data="formatData"
          :basic-data="basicData"
          :preview-scale="previewScale"
          :current-card-id="currentCardId"></component>
      </div>

      <div v-if="sampleData && previewTabActive == 'sampleFormat'"
        id="sample-viewer"
        class="sample-viewer tab-content"
        :style="previewViewerCss"
        ref="sampleViewer">
        <component v-bind:is="currentFormat.components.preview"
          ref="sampleFormat"
          :id-prefix="'sample-'"
          :is-sample="true"
          :format-data="sampleData.formatData"
          :basic-data="sampleData.basicData"
          :preview-scale="previewScale"
          :current-card-id="null"></component>
      </div>
    </div>

    <div class="preview-action">
      <div class="container-base">
        <ul>
          <li v-if="$firebase.isAuthenticated">
            <el-button id="pdf-download-preview"
              class="button-block"
              type="primary"
              :disabled="!$deviceLib.isOnline || !downloadPdfEnabled"
              v-ripple
              @click="$eventHub.$emit('download-PDF'); downloadPdfEnabled = false"><i class="el-icon-download"></i> PDFでダウンロード</el-button>
          </li>
          <li v-if="$firebase.isAuthenticated">
            <el-button id="pdf-eprint-preview"
              class="button-block"
              type="success"
              :disabled="!$deviceLib.isOnline"
              v-ripple
              @click="$eventHub.$emit('open-eprint-dialog', formatId, $refs.previewFormat, formatData.selFontStyle4DB)"><i class="el-icon-printer"></i> コンビニで印刷する</el-button>
          </li>
          <li>
            <el-button class="button-block"
              @click="closePreview"
              type="success"
              v-ripple><i class="el-icon-d-arrow-left"></i> 入力画面に戻る</el-button>
          </li>
        </ul>
      </div>
    </div>

  </div>
  <div class="container-base"
    v-if="!preview">
    <div class="footer-yagi">
      <your-yagi :your-yagi-class="{}"
        :yagi-options="{dialogEnabled:true, rubyEnabled:true, messageEnabled:true}"></your-yagi>
    </div>
  </div>

  <div v-if="isDevelopment">
    <input type="button"
           @click="devAreaVisible =! devAreaVisible"
           value="debug">
    <div v-if="devAreaVisible"
      style="background:#fff;padding:20px;">
      <el-button @click="downloadPDFWithForm">downloadPDFWithForm</el-button>
      <el-button @click="downloadPDF">downloadPDF</el-button>
      <el-button @click="setPreviewHtml">サーバー側HTML</el-button>

      <el-button @click="openSCREENSHOT">Open SCREENSHOT</el-button>
      <el-button @click="mailPDF"
        :disabled="this.mailPDFSending">PDFをメールで送信</el-button>
      <el-button @click="loadPdfBlob">PDFプレビュー</el-button>
      <iframe v-if="pdfBlob" :src="pdfBlob" width="400px" height="600px"></iframe>
      <object v-if="pdfBlob" :data="pdfBlob" type="application/pdf" width="400px" height="600px"></object>
      <pre>{{ dumpData() }}</pre>
    </div>
  </div>
</div>
</template>
<style lang="scss" src="@/assets/scss/formats.scss"></style>
<script>
import basicInfo from '@/components/BasicInfo'
import timeAgo from '@/assets/lib/time-ago-jp'
import _ from '@/assets/lib/my-lodash'
const RECENT_EDIT_SAVE_KEY = 'recentEdit'
const LAST_SAVE_DATE_SAVE_KEY = 'lastSaveDate'
// 書式1枚の高さ
const DOC_PAPER_WIDTH_PX = 794

export default {
  props: {
    formatId: {
      type: String
    },
    preview: {
      type: Boolean,
      default: false
    },
    cardId: {
      type: String
    }
  },
  data: function () {
    return {
      formatData: {},
      formatInfo: {},
      basicData: {},
      basicInfo: basicInfo,
      requiredBasicFields: [],
      currentCardId: '',
      previewHtml: '',
      previewDialogVisible: true,
      previewScale: 1,
      previewViewerCss: {},
      previewTabActive: 'previewFormat',
      mailPDFSending: false,
      saveNotifyMessage: '',
      saveNotifyMessageUpdateTimer: null,
      saveDate: null,
      devAreaVisible: false,
      currentFormat: {},
      downloadPdfEnabled: true,
      fontOptions: [
        {
          value: "font-family: 'Noto Sans JP', sans-serif;",
          label: 'Noto Sans JP'
        },
        {
          value: "font-family: 'Noto Serif JP', serif;",
          label: 'Noto Serif JP'
        },
        {
          value: "font-family: 'BIZ UDPMincho', serif;",
          label: 'BIZ UDP明朝'
        },
        {
          value: "font-family: 'DotGothic16', sans-serif;",
          label: 'ドットゴシック16'
        },
        {
          value: "font-family: 'Zen Maru Gothic', sans-serif;",
          label: 'Zen Maru ゴシック'
        },
        {
          value: "font-family: 'Kaisei Decol', serif;",
          label: 'Kaisei Decol'
        },
        {
          value: "font-family: 'Kiwi Maru', serif;",
          label: 'Kiwi Maru'
        },
        {
          value: "font-family: 'Klee One', cursive;",
          label: 'Klee One'
        },
        {
          value: "font-family: 'Kosugi', sans-serif;",
          label: 'Kosugi'
        },
        {
          value: "font-family: 'Mochiy Pop One', sans-serif;",
          label: 'Mochiy Pop One'
        },
        {
          value: "font-family: 'Reggae One', cursive;",
          label: 'Reggae One'
        },
        {
          value: "font-family: 'Shippori Mincho', serif;",
          label: 'Shippori 明朝'
        },
        {
          value: "font-family: 'Stick', sans-serif;",
          label: 'Stick'
        },
        {
          value: "font-family: 'Yuji Boku', serif;",
          label: 'Yuji Boku'
        },
        {
          value: "font-family: 'Yuji Mai', serif;",
          label: 'Yuji Mai'
        },
        {
          value: "font-family: 'Yusei Magic', sans-serif;",
          label: 'Yusei Magic'
        },
        {
          value: "font-family: 'Zen Kurenaido', sans-serif;",
          label: 'Zen Kurenaido'
        }
      ],
      fontNames: [
        {
          value: "font-family: 'Noto Sans JP', sans-serif;",
          label: 'Noto Sans JP'
        },
        {
          value: "font-family: 'Noto Serif JP', serif;",
          label: 'Noto Serif JP'
        },
        {
          value: "font-family: 'BIZ UDPMincho', serif;",
          label: 'BIZ UDP明朝'
        },
        {
          value: "font-family: 'DotGothic16', sans-serif;",
          label: 'ドットゴシック16'
        },
        {
          value: "font-family: 'Zen Maru Gothic', sans-serif;",
          label: 'Zen Maru ゴシック'
        },
        {
          value: "font-family: 'Kaisei Decol', serif;",
          label: 'Kaisei Decol'
        },
        {
          value: "font-family: 'Kiwi Maru', serif;",
          label: 'Kiwi Maru'
        },
        {
          value: "font-family: 'Klee One', cursive;",
          label: 'Klee One'
        },
        {
          value: "font-family: 'Kosugi', sans-serif;",
          label: 'Kosugi'
        },
        {
          value: "font-family: 'Mochiy Pop One', sans-serif;",
          label: 'Mochiy Pop One'
        },
        {
          value: "font-family: 'Reggae One', cursive;",
          label: 'Reggae One'
        },
        {
          value: "font-family: 'Shippori Mincho', serif;",
          label: 'Shippori 明朝'
        },
        {
          value: "font-family: 'Stick', sans-serif;",
          label: 'Stick'
        },
        {
          value: "font-family: 'Yuji Boku', serif;",
          label: 'Yuji Boku'
        },
        {
          value: "font-family: 'Yuji Mai', serif;",
          label: 'Yuji Mai'
        },
        {
          value: "font-family: 'Yusei Magic', sans-serif;",
          label: 'Yusei Magic'
        },
        {
          value: "font-family: 'Zen Kurenaido', sans-serif;",
          label: 'Zen Kurenaido'
        }
      ],
      pdfBlob: null
    }
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      this.updatePreviewHTML()
      const formData = new FormData()
      formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('pdf_option', 'A4')
      // formData.append('pdf_option', 'A4ShowPageNumberFooter')
      return formData
    },
    previewDialogStyleObject: function () {
      if (this.previewDialogVisible) {
        return {
          visibility: 'visible',
          height: 'auto'
        }
      } else {
        return {
          visibility: 'hidden',
          overflow: 'hidden',
          height: 0
        }
      }
    },
    isDevelopment: function () {
      return process.env.NODE_ENV === 'development'
    },
    sampleData: function () {
      if (this.currentFormat.sampleData) {
        return this.currentFormat.sampleData
      }
    },
    exampleSentences: function () {
      if (this.currentFormat.exampleSentences) {
        return this.currentFormat.exampleSentences
      }
      return {}
    },
    fisrtCardId: function () {
      return this.currentFormat.cards[0].id
    },
    isNextCardAvailable: function () {
      if (!this.currentCardId) return
      return this.currentCardIndex + 1 < this.currentFormat.cards.length
    },
    isPrevCardAvailable: function () {
      if (!this.currentCardId) return
      return this.currentCardIndex > 0
    },
    currentCardIndex: function () {
      if (!this.currentCardId) return -1
      let key, card
      for (key in this.currentFormat.cards) {
        card = this.currentFormat.cards[key]
        if (this.currentCardId === card.id) {
          return Number(key)
        }
      }
      return -1
    },
    currentCardTitle: function () {
      if (!this.currentCardId) return ''
      return this.currentFormat.cards[this.currentCardIndex].title
    },
    currentCardPreviewJumpId: function () {
      if (!this.currentCardId) return ''
      return this.currentFormat.cards[this.currentCardIndex].previewJumpId
    },
    nextCardLabel: function () {
      if (this.isNextCardAvailable) {
        return this.currentFormat.cards[this.currentCardIndex + 1].title
      }
      return ''
    },
    prevCardLabel: function () {
      if (this.isPrevCardAvailable) {
        return this.currentFormat.cards[this.currentCardIndex - 1].title
      }
      return ''
    }
  },
  methods: {
    preventNav(e) {
      if (!this.$firebase.isAuthenticated) {
        e.preventDefault()
        e.returnValue = ''
        this.$eventHub.$emit('open-tempdata-dialog', this.formatId, 'save')
      }
    },
    loadCurrentFormat: function () {
      const result = this.$site.getFormatById(this.formatId)
      if (result) {
        this.currentFormat = result
      } else {
        console.error('result not found:', this.formatId, result)
      }
    },
    dumpData: function () {
      return JSON.stringify({
        'basicData': this.basicData,
        'formatData': this.formatData
      }, null, 2)
    },
    previewScrollTo: function (id) {
      if (!id) {
        return
      }
      this.$nextTick(function () {
        const element = document.getElementById(id)
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'center'
          })
        }
      })
    },
    loadTempdata: function () {
      this.$eventHub.$emit('open-tempdata-dialog', this.formatId, 'load')
    },
    showTempdata: function () {
      this.$eventHub.$emit('open-tempdata-dialog', this.formatId, 'save')
    },
    showPreview: function () {
      this.previewDialogVisible = true
      this.previewTabActive = 'previewFormat'
      this.setPreviewScale()
      this.$router.push({
        name: 'formatPreview',
        params: {
          formatId: this.formatId,
          cardId: this.cardId
        }
      })
      this.$nextTick(function () {
        this.previewScrollTo(this.currentCardPreviewJumpId)
      })
      const app = this
      this.$iterateStorage(function (value, key, iterationNumber) {
          if (key === 'basicData') {
            app.username = value.lastName + '' + value.firstName
            for (const label_name in app.fontOptions) {
              app.fontOptions[label_name].label = '職務経歴書（' + app.fontNames[label_name].label + '）'
            }
          }
      }, function (err) {})
      this.$eventHub.$emit('show-preview-from-card', this.currentCardPreviewJumpId)
    },
    showPreview4Conv: function () {
      this.saveBackup()
      this.previewDialogVisible = true
      this.previewTabActive = 'previewFormat'
      this.setPreviewScale()
      this.$router.push({
        name: 'formatPreview',
        params: {
          formatId: this.formatId,
          cardId: this.cardId
        }
      })
      this.$nextTick(function () {
        this.previewScrollTo(this.currentCardPreviewJumpId)
      })
      this.$eventHub.$emit('show-preview-from-card', this.currentCardPreviewJumpId)
    },
    closePreview: function () {
      this.previewDialogVisible = false
      if (this.cardId) {
        this.$router.push({
          name: 'formatEditCard',
          params: {
            formatId: this.formatId,
            cardId: this.cardId
          }
        })
      }
    },
    setRecentEdit: function (data) {
      if (!data) {
        data = {
          timestamp: new Date().getTime(),
          FormatId: this.formatId,
          FormatTitle: this.currentFormat.title,
          cardId: this.currentCardId,
          cardTitle: this.currentCardTitle
        }
      }
      this.$setItem(RECENT_EDIT_SAVE_KEY, data)
      this.$eventHub.$emit('change-recent-edit', data)
    },
    setPreviewScale: function () {
      let viewerRef = this.$refs.previewViewer
      this.$nextTick(function () {
        if (!viewerRef) return
        if (this.previewTabActive === 'sampleFormat') {
          const clientWidth = this.$refs[this.previewTabActive].$el.clientWidth
          this.previewScale = clientWidth / Math.max(clientWidth, DOC_PAPER_WIDTH_PX)
        } else {
          const clientWidth = this.$refs.previewViewer.clientWidth
          this.previewScale = clientWidth / Math.max(clientWidth, DOC_PAPER_WIDTH_PX)
        }
        this.$nextTick(function () {
          this.setPreviewHeight()
        })
      })
    },
    setPreviewHeight: function () {
      if (!this.$refs[this.previewTabActive]) {
        console.log('!this.$refs[this.previewTabActive]', this.$refs[this.previewTabActive])
        return
      }
      if (!this.$refs[this.previewTabActive].$refs.previewMain) {
        console.log('!this.$refs[this.previewTabActive].$refs.previewMain', this.$refs[this.previewTabActive].$refs.previewMain)
        return
      }
      const height = this.$refs[this.previewTabActive].$refs.previewMain.getBoundingClientRect().height
      if (!height) {
        return
      }
      this.previewViewerCss = {
        height: height + 30 + 'px'
      }
    },
    cardIdExists: function (cardId) {
      for (const key in this.currentFormat.cards) {
        if (this.currentFormat.cards[key].id === cardId) {
          return true
        }
      }
      return false
    },
    goFirstCard: function () {
      this.$router.replace({
        name: 'formatEditCard',
        params: {
          formatId: this.currentFormat.id,
          cardId: this.fisrtCardId
        }
      })
    },
    goCurrentCard: function () {
      this.previewDialogVisible = false
      this.$router.push({
        name: 'formatEditCard',
        params: {
          formatId: this.currentFormat.id,
          cardId: this.currentCardId
        }
      })
      this.setRecentEdit()
      this.$eventHub.$emit('deactivate-history-item')
      this.$eventHub.$emit('card-changed', this.currentCardId)
    },
    scrollToCurrentStep: function () {
      this.$nextTick(function () {
        if (this.currentCardIndex < 0) {
          return
        }
        this.$refs.steps[this.currentCardIndex].scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'center'
        })
      })
    },
    goCardTo: function (cardId) {
      if (!this.cardIdExists(cardId)) {
        this.goFirstCard()
        return
      }
      this.currentCardId = cardId
      this.goCurrentCard()
      this.scrollToCurrentStep()
      if (!this.$firebase.isAuthenticated) {
        if (this.currentCardId != 'profile' && this.currentCardId != 'letterprofile' && this.currentCardId != 'output') {
          this.$eventHub.$emit('open-tempdata-dialog', this.formatId, 'save')
        }
      }
    },
    goNextCard: function () {
      if (this.isNextCardAvailable) {
        this.currentCardId = this.currentFormat.cards[this.currentCardIndex + 1].id
        this.goCurrentCard()
        this.scrollToCurrentStep()
        if (!this.$firebase.isAuthenticated) {
          if (this.currentCardId != 'profile' && this.currentCardId != 'letterprofile' && this.currentCardId != 'output') {
            this.$eventHub.$emit('open-tempdata-dialog', this.formatId, 'save')
          }
        }
      }
    },
    goPrevCard: function () {
      if (this.isPrevCardAvailable) {
        this.currentCardId = this.currentFormat.cards[this.currentCardIndex - 1].id
        this.goCurrentCard()
        this.scrollToCurrentStep()
      }
    },
    swipeNextCard: function () {
      if (this.$deviceLib.isMobileDevice) {
        this.goNextCard()
      }
    },
    swipePrevCard: function () {
      if (this.$deviceLib.isMobileDevice) {
        this.goPrevCard()
      }
    },
    updateFormatData: function (data) {
      this.formatData = data
      this.downloadPdfEnabled = true
    },
    updateBasicData: function (data) {
      this.basicData = data
      this.downloadPdfEnabled = true
    },
    saveNotify: function () {
      const now = new Date()
      this.$setItem(LAST_SAVE_DATE_SAVE_KEY, now)
      this.saveDate = now
      this.updateSaveNotifyMessage()
    },
    updateSaveNotifyMessage: function () {
      if (this.saveDate) {
        this.saveNotifyMessage = timeAgo(this.saveDate)
      } else {
        this.saveNotifyMessage = ''
      }
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.currentFormat.id}${dateString}.${ext}`
    },
    updatePreviewHTML: function () {
      if (this.$refs.previewFormat) {
        this.previewHtml = this.$refs.previewFormat.$el.innerHTML
      } else {
        console.error('this.$refs.previewFormat', this.$refs)
      }
    },
    setPreviewHtml: function () {
      this.updatePreviewHTML()
      const param = {
        app_html: this.cleanedPreviewHtml
      }
      this.submitForm(this.$varuna.endPoints.html, param, 'POST')
    },
    saveDownloadLog: function (pdfBlob, filename) {
      // PDF Download log
      if (this.$firebase.isAuthenticated) {
        this.$firebase.addPdfDownloadLog(
          this.currentFormat.id,
          this.currentFormat.title, {
            formatData: this.formatData,
            basicData: this.basicData
          },
          pdfBlob,
          filename
        )
      }
    },
    loadPdfBlob: function () {
      /*
      PDFプレビューテスト用
      */
      const previewOpened = this.previewDialogVisible
      if (!previewOpened) {
        this.previewDialogVisible = true
      }
      const filename = this.createFilename('pdf')
      const app = this
      this.$nextTick(function () {
        this.updatePreviewHTML()
        const formData = this.pdfFormData
        formData.append('version', '2')
        formData.append('device_flg', app.$deviceLib.isMobileDevice ? 'SP': 'PC')
        this.$axios({
          url: this.$varuna.endPoints.pdf + filename,
          method: 'post',
          data: formData,
          responseType: 'blob',
          timeout: 60000
        }).then((response) => {
          const pdfBlob = new Blob([response.data], {
            type: 'application/pdf'
          })
          this.pdfBlob = window.URL.createObjectURL(pdfBlob)
        }).catch(function (error) {
          app.$message({
            message: 'ダウンロードに失敗しました。しばらくしてからやり直してください',
            type: 'error'
          })
          app.downloadPdfEnabled = true
          console.error(error)
          app.$gtm.sendError('pdf download', `download pdf failed ${error}`)
        })
      })
      if (!previewOpened) {
        this.previewDialogVisible = false
      }
    },
    downloadPDFWithLink: function () {
      /*
      <a download="filename">を使う
      jsでPDFのBlobを受け取れるからログに保存できる
      IEでは動かない
      */
      const previewOpened = this.previewDialogVisible
      if (!previewOpened) {
        this.previewDialogVisible = true
      }
      const filename = this.createFilename('pdf')
      const app = this
      this.$nextTick(function () {
        this.updatePreviewHTML()
        const formData = this.pdfFormData
        formData.append('version', '2')
        formData.append('format_id', app.formatId)
        formData.append('uuid', app.$firebase.user.uid)
        formData.append('device_flg', app.$deviceLib.isMobileDevice ? 'SP': 'PC')
        formData.append('font_name', app.formatData.selFontStyle4DB)
        this.$axios({
          url: this.$varuna.endPoints.pdf + filename,
          method: 'post',
          data: formData,
          responseType: 'blob',
          timeout: 40000
        }).then((response) => {
          app.saveBackup()
          const pdfBlob = new Blob([response.data], {
            type: 'application/pdf'
          })
          const url = window.URL.createObjectURL(pdfBlob)
          // saveDownloadLog(pdfBlob, filename)
          let link = document.createElement('a')
          link.href = url
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }).catch(function (error) {
          app.$message({
            message: 'ダウンロードに失敗しました。しばらくしてからやり直してください',
            type: 'error'
          })
          app.downloadPdfEnabled = true
          console.error(error)
          app.$gtm.sendError('pdf download', `download pdf failed ${error}`)
        })
      })
      if (!previewOpened) {
        this.previewDialogVisible = false
      }
    },
    downloadPDFWithForm: function (forceDownload) {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      this.previewDialogVisible = true
      this.$nextTick(function () {
        this.updatePreviewHTML()
        let pdfURL = this.$varuna.endPoints.pdf
        if (forceDownload) {
          pdfURL = this.$varuna.endPoints.pdfDownload
        }
        const param = {
          app_html: this.cleanedPreviewHtml
        }
        this.submitForm(pdfURL + this.createFilename('pdf'), param, 'POST')
      })
    },
    downloadPDF: function () {
      let medleyID = 0
      if (this.formatId == "nursing_care_shokumukeirekisho") {
        medleyID = 1
      } else if (this.formatId == "childminder_shokumukeirekisho") {
        medleyID = 2
      } else if (this.formatId == "pharmacist_shokumukeirekisho") {
        medleyID = 3
      } else if (this.formatId == "occupational_therapist_shokumukeirekisho") {
        medleyID = 4
      } else if (this.formatId == "dental_hygienist_shokumukeirekisho") {
        medleyID = 5
      } else if (this.formatId == "nurse_shokumukeirekisho") {
        medleyID = 7
      } else if (this.formatId == "physical_therapist_shokumukeirekisho") {
        medleyID = 8
      } else if (this.formatId == "speech_hearing_therapist_shokumukeirekisho") {
        medleyID = 9
      }
      if (medleyID > 0) {
        this.$eventHub.$emit('open-medley-dialog', this.formatId, this.$refs.previewFormat, medleyID)
      } else {
        this.$eventHub.$emit('open-adtop-dialog', this.formatId, this.$refs.previewFormat, this.basicData.email)
      }
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      if (this.$deviceLib.isIE) {
        this.downloadPDFWithForm(true)
      } else {
        this.downloadPDFWithLink()
      }
    },
    saveBackup: function () {
      if (this.$yagi.profile.name) {
        this.saveLabel = this.$yagi.profile.name + 'のバックアップ'
      } else {
        this.saveLabel = 'バックアップ'
      }
      this.$firebase.addBackup(this.saveLabel, 'user')
    },
    mailPDF: async function () {
      let medleyID = 0
      if (this.formatId == "nursing_care_shokumukeirekisho") {
        medleyID = 1
      } else if (this.formatId == "childminder_shokumukeirekisho") {
        medleyID = 2
      } else if (this.formatId == "pharmacist_shokumukeirekisho") {
        medleyID = 3
      } else if (this.formatId == "occupational_therapist_shokumukeirekisho") {
        medleyID = 4
      } else if (this.formatId == "dental_hygienist_shokumukeirekisho") {
        medleyID = 5
      } else if (this.formatId == "nurse_shokumukeirekisho") {
        medleyID = 7
      } else if (this.formatId == "physical_therapist_shokumukeirekisho") {
        medleyID = 8
      } else if (this.formatId == "speech_hearing_therapist_shokumukeirekisho") {
        medleyID = 9
      }
      if (medleyID > 0) {
        this.$eventHub.$emit('open-medley-dialog', this.formatId, this.$refs.previewFormat, medleyID)
      } else {
        this.$eventHub.$emit('open-adtop-dialog', this.formatId, this.$refs.previewFormat, this.basicData.email)
      }
      const app = this
      // alert('システムメンテナンス中です。サービス再開までしばらくお待ちください。再開はお知らせにて掲載いたします。')
      // return
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      if (this.mailPDFSending) {
        this.$message({
          message: '現在メール送信中です',
          type: 'error'
        })
        return
      }
      if (!this.$firebase.user.email) {
        if (!app.basicData.email) {
          this.$message({
            message: '連絡先にてメールアドレスを入力してください',
            type: 'error'
          })
          return
        }
      } else {
        if (this.$firebase.user.email.indexOf('@privaterelay.appleid.com') > 0 && !app.basicData.email) {
          this.$message({
            message: '連絡先にてメールアドレスを入力してください',
            type: 'error'
          })
          return
        }
      }
      this.updatePreviewHTML()
      this.mailPDFSending = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('format_id', this.formatId)
      if (!this.$firebase.user.email && app.basicData.email || 
        (this.$firebase.user.email.indexOf('@privaterelay.appleid.com') > 0) && app.basicData.email) {
        formData.append('inputemail', app.basicData.email)
        const subformData = new FormData()
        subformData.append('uuid', this.$firebase.user.uid)
        subformData.append('email', app.basicData.email)
        subformData.append('app_flag', '')
        subformData.append('site_flag', 'k')
        subformData.append('device_flag', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
        this.$axios
          .post(this.$varuna.endPoints.login, subformData)
        // this.$firebase.user.updateEmail(app.basicData.email).then(() => {
        // }).catch((error) => {
        // });
      }
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('yaginame', this.$yagi.profile.name)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('filename', this.createFilename('pdf'))
      formData.append('font_name', this.formatData.selFontStyle4DB)
      formData.append('version', '2')
      this.$axios
        .post(this.$varuna.endPoints.pdfMail, formData, {timeout: 60000})
        .then(function (response) {
          app.saveBackup()
          if (!app.$firebase.user.email && app.basicData.email || 
            (app.$firebase.user.email.indexOf('@privaterelay.appleid.com') > 0 && app.basicData.email)) {
            app.$message({
              message: app.basicData.email + 'に送信しました',
              type: 'success'
            })
          } else {
            app.$message({
              message: app.$firebase.user.email + 'に送信しました',
              type: 'success'
            })
          }
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          console.error(error)
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.mailPDFSending = false
        })
    },
    openSCREENSHOT: function () {
      this.updatePreviewHTML()
      const param = {
        app_html: this.cleanedPreviewHtml
      }
      this.submitForm(this.$varuna.endPoints.screenshot + this.createFilename('png'), param, 'POST')
    },
    submitForm: function (url, data, method) {
      const form = document.createElement('form')
      document.body.appendChild(form)
      form.action = url
      form.method = method
      for (const name in data) {
        let input = document.createElement('input')
        input.type = 'hidden'
        input.name = name
        input.value = data[name]
        form.appendChild(input)
      }
      form.submit()
      document.body.removeChild(form)
    },
    hidePreviewDialog: function (e) {
      if (this.previewDialogVisible) {
        this.previewDialogVisible = false
      }
    },
    selectFont: function() {
      const app = this
      this.formatData.selFontStyle = this.formatData.selFont
      
      for (const label_name in this.fontOptions) {
        if (this.fontNames[label_name].value == this.formatData.selFont) {
          this.formatData.selectedFontName = '選択したフォント（' + this.fontNames[label_name].label + '）'
          this.formatData.selFontStyle4DB = this.fontNames[label_name].label
        }
      }
    },
    setPreviewScaleDebounce: function (e) {
      _.debounce(this.setPreviewScale, 1000)
    }
  },
  watch: {
    'cardId': function () {
      this.currentCardId = this.cardId
      if (this.currentCardIndex < 0) {
        this.goFirstCard()
      }
    },
    previewTabActive: function () {
      this.setPreviewScale()
    }
  },
  beforeMount: function () {
    this.loadCurrentFormat()
    if (this.currentFormat) {
      this.requiredBasicFields = this.currentFormat['requiredBasicFields']
    }
    if (this.cardId) {
      this.currentCardId = this.cardId
    }
    if (!this.$firebase.isAuthenticated) {
      if (this.currentCardId != 'profile' && this.currentCardId != '' && this.currentCardId != 'letterprofile' && this.currentCardId != 'output') {
        console.error('open-tempdata-dialog：' + this.currentCardId)
        this.$eventHub.$emit('open-tempdata-dialog', this.formatId, 'save')
      }
    }
    window.addEventListener("beforeunload", this.preventNav)
  },
  beforeDestroy() {
    // Don't forget to clean up event listeners
    window.removeEventListener("beforeunload", this.preventNav)
  },
  mounted: function () {
    if (this.currentCardIndex < 0) {
      this.goFirstCard()
    }
    this.$eventHub.$on('local-format-data-loaded', this.setPreviewHeight)
    this.$eventHub.$on('basic-data-changed', this.updateBasicData)
    this.$eventHub.$on('format-data-changed', this.updateFormatData)
    this.$eventHub.$on('backup-loaded-' + RECENT_EDIT_SAVE_KEY, this.setRecentEdit)
    this.$eventHub.$on('save-complete-notify', this.saveNotify)
    this.$eventHub.$on('download-PDF', this.downloadPDF)
    this.$eventHub.$on('mail-PDF', this.mailPDF)
    this.$eventHub.$on('go-card-to', this.goCardTo)
    this.$eventHub.$on('show-preview', this.showPreview)
    this.$eventHub.$on('show-preview-4conv', this.showPreview4Conv)
    if (this.preview === false) {
      this.closePreview()
    } else if (this.preview === true) {
      this.showPreview()
    }
    const app = this
    this.$getItem(LAST_SAVE_DATE_SAVE_KEY, function (err, data) {
      if (err) {
        console.error(err)
        return
      }
      app.saveDate = data
      app.updateSaveNotifyMessage()
    })
    // set event listeners and timer
    window.addEventListener('popstate', this.hidePreviewDialog, false)
    window.addEventListener('resize', this.setPreviewScaleDebounce, false)
    this.saveNotifyMessageUpdateTimer = setInterval(this.updateSaveNotifyMessage, 5000)
    this.scrollToCurrentStep()
  },
  destroyed: function () {
    // remove event listeners and timer
    this.$eventHub.$off('local-format-data-loaded', this.setPreviewHeight)
    this.$eventHub.$off('basic-data-changed', this.updateBasicData)
    this.$eventHub.$off('format-data-changed', this.updateFormatData)
    this.$eventHub.$off('backup-loaded-' + RECENT_EDIT_SAVE_KEY, this.setRecentEdit)
    this.$eventHub.$off('save-complete-notify', this.saveNotify)
    this.$eventHub.$off('download-PDF', this.downloadPDF)
    this.$eventHub.$off('mail-PDF', this.mailPDF)
    this.$eventHub.$off('go-card-to', this.goCardTo)
    this.$eventHub.$off('show-preview', this.showPreview)
    this.$eventHub.$off('show-preview-4conv', this.showPreview4Conv)
    window.removeEventListener('popstate', this.hidePreviewDialog, false)
    window.removeEventListener('resize', this.setPreviewScaleDebounce, false)
    clearInterval(this.saveNotifyMessageUpdateTimer)
  }
}
</script>
